module.exports = __webpack_public_path__ + "img/user2-160x160.eafc49f5.jpg";